import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import toast from "react-hot-toast";
import Breadcrumbs from "../../components/Breadcrumbs";
import { getAccountTypesByAgreement } from "../../api/Agreement";
import { getBillingGroupsByAgreement } from "../../api/BillingGroups";
import { getUserProgramsByAgreement, createUserProgram } from "../../api/Agreement";
import ProgramForm from "../../components/userProgram/ProgramForm";

const CreateUserProgramPage = () => {
  const { agreementPublicId } = useParams();
  const [selected, setSelected] = useState([]);
  const { getAccessToken } = useAuth();

  const [accountTypes, setAccountTypes] = useState([]);
  const [accountTypesLoaded, setAccountTypesLoaded] = useState(false);
  const [billingGroups, setBillingGroups] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [programsLoaded, setProgramsLoaded] = useState(false);
  const [program, setProgram] = useState({
    displayName: "",
    description: "",
    agreementPublicId: agreementPublicId || "",
  });
  const [originalProgram, setOriginalProgram] = useState(program);

  const navigate = useNavigate();
  const onChange = (updated) => {
    setSelected(updated);
  };

  const programNames = programs.map((program) => program.displayName);

  useEffect(() => {
    fetchPrograms();
  }, [agreementPublicId]);

  useEffect(() => {
    if (program && originalProgram) {
      const isEqual = JSON.stringify(program) === JSON.stringify(originalProgram);
      setHasChanges(!isEqual);
    }
  }, [program, originalProgram]);

  const fetchPrograms = async () => {
    try {
      const accessToken = await getAccessToken();
      const agreementPrograms = await getUserProgramsByAgreement(agreementPublicId, accessToken);

      setPrograms(agreementPrograms);
      setProgramsLoaded(true);
    } catch (error) {
      console.error("Failed to fetch programs:", error);
      setProgramsLoaded(true);
    }
  };

  const handleCreateUserProgram = async () => {
    try {
      const accessToken = await getAccessToken();
      if (!accessToken) {
        toast.error("Authorization failed. Please log in again.");
        return;
      }

      const payload = {
        agreementPublicId: program.agreementPublicId,
        displayName: program.displayName,
        description: program.description,
      };
      console.log("User program CREATED:", payload);

      await createUserProgram(payload, accessToken);

      toast.success("User program created successfully", {
        iconTheme: {
          primary: "#4CAF50",
          secondary: "#DFF2BF",
        },
      });
    } catch (error) {
      console.error("Failed to create user program:", error);
      toast.error("Failed to create user program");
    }
    navigate(-1);
  };

  const toggleSelection = (option) => {
    const updated = selected.includes(option)
      ? selected.filter((item) => item !== option)
      : [...selected, option];
    onChange(updated);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="page-content">
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Create user program</h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleBackClick}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!hasChanges}
                  onClick={handleCreateUserProgram}
                >
                  Save user program
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
              <ProgramForm
                program={program}
                setProgram={setProgram}
                setHasChanges={setHasChanges}
                programs={programs}
                programsLoaded={programsLoaded}
                selected={selected}
                onChange={onChange}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CreateUserProgramPage;

